<h3>
    <i ng-if="item.isProtected" class="fa fa-lock" style="color: gray" title="{{'userRole.isProtected'|translate}}"></i>
    <a ng-click="viewDetails($event, item)" ng-bind-html="item.name|cHighlight:highlight"></a>
</h3>
<p>
    {{item.description}}
</p>